import { t } from "@lingui/macro";
import { ArrowLeftIcon, HorseIcon } from "@phosphor-icons/react";
import { Button } from "@reactive-resume/ui";
import { Link } from "react-router";

import { LocaleProvider } from "@/client/providers/locale";

export const NotFoundPage = () => {
  return (
    <LocaleProvider>
      <main className="flex min-h-screen items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 p-4">
        <div className="w-full max-w-md space-y-8 text-center">
          <div className="space-y-4">
            <div className="mx-auto inline-flex h-24 w-24 items-center justify-center rounded-2xl bg-white/50 shadow-xl backdrop-blur-sm">
              <ArrowLeftIcon size={48} className="text-gray-500" />
            </div>
            <h1 className="flex flex-col items-center text-6xl font-black text-gray-900">
              <span>4</span>
              <span className="bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-3xl text-transparent">
                0
              </span>
              <span>4</span>
            </h1>
            <h2 className="text-xl font-bold text-gray-900">{t`Page Not Found`}</h2>
          </div>

          <p className="text-sm leading-relaxed text-gray-600">
            {t`Désolé, la page que vous cherchez n'existe pas ou a été déplacée.`}
          </p>

          <div className="flex flex-col justify-center gap-3 sm:flex-row">
            <Button asChild size="lg" className="min-w-[140px]">
              <Link to="/">
                <HorseIcon size={20} className="mr-2" />
                {t`Accueil`}
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="min-w-[140px]">
              <Link to="/client/user-space">{t`Tableau de bord`}</Link>
            </Button>
          </div>

          <p className="text-xs text-gray-500">
            {t`Utilisez la barre de navigation pour explorer le site.`}
          </p>
        </div>
      </main>
    </LocaleProvider>
  );
};
